import { render, staticRenderFns } from "./summary-of-active-account.vue?vue&type=template&id=2171363f&"
import script from "./summary-of-active-account.vue?vue&type=script&lang=js&"
export * from "./summary-of-active-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports